import { css } from '@emotion/react';

export default ({ theme }) => css`
  .MuiInputAdornment-root {
    position: absolute;
    right: 34px;
  }
`;
